import { Injectable, inject, signal, Signal } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly apiService = inject(ApiService);
  private readonly userId = signal<string | null>(null);

  /**
   * Fetches the list of users from the API
   * @returns Observable containing the user list
   */
  getUserList(payload: any): Observable<any> {
    return this.apiService.post<any>(API_ENDPOINTS.USERS.LIST,payload);
  }

  verifyUser(payload: any): Observable<any> {
    return this.apiService.post<any>(API_ENDPOINTS.USERS.VERIFY,payload);
  }
  storeUserId(userId: string): void {
    this.userId.set(userId);
  }

  getStoredUserId(): string | null {
    return this.userId();
  }

  get userIdSignal(): Signal<string | null> {
    return this.userId.asReadonly();
  }

  getUsersCount( payload: any ): Observable<any> {
    return this.apiService.post<any>(API_ENDPOINTS.USERS.COUNT, payload);
  }
}

